import { ReactElement, RefObject, ReactNode } from 'react';
import { Box } from '@chakra-ui/react';

import Heading from 'components/atoms/heading/index';
import Button from 'components/atoms/button/index';
import BadgeText from 'components/atoms/badgeText';
import { IconType } from 'lib/@types';

export interface FreePlatformCtoProps {
  freePlatformBadge: string | ReactNode;
  freePlatformTitle: string | ReactNode;
  freePlatformButton: string;
  freePlatformButtonIcon: IconType;
  formRef?: RefObject<HTMLDivElement>;
}

const FreePlatformCto = ({
  freePlatformBadge,
  freePlatformTitle,
  freePlatformButton,
  freePlatformButtonIcon,
  formRef,
}: FreePlatformCtoProps): ReactElement => (
  <Box
    minH='100%'
    px={8}
    w={['100%', '100%', '500px', '500px']}
    ml={[0, 0, 4, 4]}
    mb={[16, 16, 0, 0]}
  >
    <BadgeText>{freePlatformBadge}</BadgeText>

    <Heading format='h2' w='100%' mb='8'>
      {freePlatformTitle}
    </Heading>

    <Button
      rightIcon={freePlatformButtonIcon}
      p='8px 0px'
      onClick={() => formRef?.current?.scrollIntoView()}
      _hover={{
        bgColor: 'primary.500',
      }}
    >
      {freePlatformButton}
    </Button>
  </Box>
);

export default FreePlatformCto;
